import { ErrorBoundary as MosaicErrorBoundary, MessageBox } from '@opendoor/mosaic';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import { Sentry } from '@opendoor/observability';
import { ErrorBoundaryFallbackProps } from '@opendoor/mosaic/dist/components/ErrorBoundary/ErrorBoundary';

interface ErrorBoundaryProps {
  children?: any;
}

const OhNoFallback = ({ error, errorInfo }: ErrorBoundaryFallbackProps) => {
  Sentry.withScope((scope) => {
    scope.setTag('source', 'ErrorBoundary');
    scope.setExtras({ 'error-info': errorInfo });
    Sentry.captureException(error);
  });
  return (
    <MessageBox
      image={<ErrorOutlineRoundedIcon className="h-5 w-5" />}
      description="We're experiencing technical difficulties. Try reloading the page"
    />
  );
};

const ErrorBoundary = ({ children }: ErrorBoundaryProps) => {
  return <MosaicErrorBoundary fallback={OhNoFallback}>{children}</MosaicErrorBoundary>;
};

export default ErrorBoundary;
